module.exports = __webpack_public_path__ + "media/bootstrap-icons/facebook-1bc02887.svg";